import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter, Route, Switch, Redirect } from 'react-router-dom';

class PublicAppContainer extends Component {
  render () {
    return <Switch>
      {this.props.publicRoutes.routes.map(route => (
        <Route {...route} key={route.path} />
      ))}
      <Redirect to="/login" push />
    </Switch>;
  }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = {};

PublicAppContainer.propTypes = {
  publicRoutes: PropTypes.object.isRequired,
};

// withRouter is imported to bypass connect blocking router status
// https://github.com/reactjs/react-redux/issues/507
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PublicAppContainer));
